/*
 * @Author: huangziyin
 * @Date: 2025-04-21 13:59:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-04-21 14:00:54
 * @Description: 请填写简介
 */
const groupMap = {
  // 商品分组列表
  getGroupList: '/usb/uwb-app/api/v1/group/list',
  // 商品分组添加
  addGroup: '/usb/uwb-app/api/v1/group/add',
  // 商品分组删除
  deleteGroup: '/usb/uwb-app/api/v1/group/delete',
  // 分组商品添加
  addGroupProduct: '/usb/uwb-app/api/v1/group/product/add',
  // 分组商品删除
  deleteGroupProduct: '/usb/uwb-app/api/v1/group/product/delete',
  // 分组商品分页查询
  getGroupProductList: '/usb/uwb-app/api/v1/group/product/page',
};

export default groupMap;
